import {parseDate} from "element-ui/lib/utils/date-util";
import { isArray, isEqual, isObject, transform } from 'lodash'

import BillingServer from '@/api/billing'

export const COMPONENT_MAIN = 'ContractMain';
export const COMPONENT_TASK_MAIN = 'ContractTaskMain';
export const COMPONENT_LIST = 'ContractList';
export const COMPONENT_TASK_LIST = 'ContractTaskList';
export const COMPONENT_DETAIL = 'ContractDetail';
export const COMPONENT_TASK_DETAIL = 'ContractTaskDetail';


export const TAB_LIST = 'list';
export const OPERATION_LIST_DEFAULT = 'list.default';

export const TAB_DETAIL = 'detail';
export const OPERATION_DETAIL_SHOW = 'detail.show';
export const OPERATION_DETAIL_ADD = 'detail.add';
export const OPERATION_DETAIL_EDIT = 'detail.edit';

export const FN_SET_OPERATION = 'setOperation';
export const FN_SET_TAB = 'setTab';

export const FN_LIST_QUERY = 'query';

export const FN_TO_DETAIL_SHOW = 'toDetailShow';

export const PERMISSION_ADD = null;
export const PERMISSION_EDIT = null;
export const PERMISSION_DELETE = null;

export const ENUM_CONTRACT_WORKFLOW_STATUS_DRAFT = 'DRAFT'; // 草稿
export const ENUM_CONTRACT_WORKFLOW_STATUS_WAPPRNEW = 'WAPPRNEW'; // 新建待审批
export const ENUM_CONTRACT_WORKFLOW_STATUS_CONFIRMED = 'CONFIRMED'; // 已确认
export const ENUM_CONTRACT_WORKFLOW_STATUS_WACHA = 'WACHA'; // 待变更
export const ENUM_CONTRACT_WORKFLOW_STATUS_WAPPRCHA = 'WAPPRCHA'; // 变更待审批

export function getContractById(id) {
    return new Promise((resolve, reject) => {
        BillingServer.contract.get(id).then((res) => {
            if (String(res.data.code) === '200' || res.data.success) {
                resolve(res.data.data);
            } else {
                reject(res.data.responseMessage);
            }
        }, (error) => {
            reject(error);
        });
    });
}

// 合同是否可以被修改
export function contractIsEditable(contract) {
    return contract != null && contract.id != null &&
        (contract.flag == null || contract.flag === 1 || contract.flag === 0 &&
            (contract.workflowStatus == null || contract.workflowStatus === '' ||
                contract.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_DRAFT ||
                contract.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_WACHA))
}

// 合同是否可以被删除
export function contractIsDeletable(contract) {
    return contract != null && contract.id != null &&
        (contract.flag == null || contract.flag === 1 || contract.flag === 0 &&
            contract.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_DRAFT)
}

// 合同是否可以更新商机
export function contractIsCanUpdateBusinessOpportunities(contract) {
    return contract != null && contract.id != null &&
      (contract.flag == null || contract.flag === 1 || contract.flag === 0 &&
        (contract.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_DRAFT ||
          contract.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_WACHA));
}

// 合同是否可以更新 条款
export function contractIsCanUpdateTerms(contract) {
    return contract != null && contract.id != null &&
      (contract.flag == null || contract.flag === 1 || contract.flag === 0 &&
        (contract.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_DRAFT ||
          contract.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_WACHA));
}

// 合同可以添加附件
export function contractIsCanAddAttachment(contract) {
    return contractIsEditable(contract);
}

// 合同的附件是否可以删除
export function attachmentIsCanDelete(contract, attachment) {
    let can = false;
    if (contract == null || contract.id == null) {
        can = false;
    } else if (contract.flag == null || contract.flag === 1) {
        can = true;
    } else if (contract.flag === 0 && (contract.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_DRAFT ||
        contract.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_WACHA)) {
        if (contract.lastConfirmTime == null) {
            can = true; // 没有确认过
        } else {
            can = compareDate(attachment.createDate, contract.lastConfirmTime) > 0;
        }
    }
    return can;
}

// 合同是否可以添加计费项
export function contractIsCanAddItem(contract) {
    return contract != null && contract.id != null &&
        (contract.flag == null || contract.flag === 1 || contract.flag === 0 &&
            (contract.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_DRAFT ||
                contract.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_WACHA));
}

function checkAttachments(contract, attachments) {
    let success;
    if (attachments == null || attachments.length === 0) {
        success = false;
    } else if (contract.lastConfirmTime == null){
        success = true;
    } else {
        success = false;
        for (let i = attachments.length - 1; i >= 0; i--) {
            if (compareDate(attachments[i].createDate, contract.lastConfirmTime) > 0) {
                success = true;
                break;
            }
        }
    }
    return success;
}

export function contractCanSendWorkflow(contract, attachments) {
    let success, message = '';
    if (contract == null || contract.id == null) {
        success = false;
    } else if (contract.flag === 0 && (contract.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_DRAFT)) {
        success = checkAttachments(contract, attachments);
        if (!success) {
            message = '请在合同详情页面的附件模块上传附件后再操作！';
        }
    } else {
        success = true;
    }
    return {
        success: success,
        message: message
    };
}

export function contractCanAudit(contract, attachments) {
    let success, message = '';
    if (contract == null || contract.id == null) {
        success = false;
    } else if (contract.flag === 0 && (contract.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_WACHA)) {
        success = checkAttachments(contract, attachments);
        if (!success) {
            message = '请在合同的附件模块上传附件后再操作!';
        }
    } else {
        success = true;
    }
    return {
        success: success,
        message: message
    };
}

// 合同计费项是否可以编辑
export function contractItemIsCanEdit(contract, contractItem) {
    return contractIsCanAddItem(contract) && contractItem != null && contractItem.uuid != null && contractItem.release !== 3;
}

// 合同计费项是否可以删除
export function contractItemIsCanDelete(contract, contractItem) {
    return contractItemIsCanEdit(contract, contractItem);
}

// 合同是否可以创建账单
export function contractCanAddBill(contract) {
    return contract != null && contract.id != null && (contract.flag == null || contract.flag === 1 ||
        contract.flag === 0 && contract.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_CONFIRMED)
}

// 合同是否可以创建账单
export function contractCanEditBill(contract) {
    return contract != null && contract.id != null && (contract.flag == null || contract.flag === 1 ||
        contract.flag === 0 && contract.workflowStatus === ENUM_CONTRACT_WORKFLOW_STATUS_CONFIRMED)
}

export async function contractCanAddBillByContractId(contractId) {
    let contract = await getContractById(contractId);
    return contractCanAddBill(contract);
}

export async function contractCanEditBillByContractId(contractId) {
    let contract = await getContractById(contractId);
    return contractCanEditBill(contract);
}

export function compareDate(date1, date2) {
    let flag;
    if (date1 == null && date2 == null) {
        flag = 0;
    } else if (date1 != null && date2 == null) {
        flag = 1;
    } else if (date1 == null && date2 != null) {
        flag = -1;
    } else {
        let time1 = parseDate(date1, 'yyyy-MM-dd HH:mm:ss').getTime();
        let time2 = parseDate(date2, 'yyyy-MM-dd HH:mm:ss').getTime();
        if (time1 === time2) {
            flag = 0;
        } else if (time1 < time2) {
            flag = -1;
        } else {
            flag = 1;
        }
    }
    return flag;
}


export const deepDiffBetweenObjects = (object, base, callback) => {
    const changes = (object, base) => {
        return transform(object, (result, value, key) => {
        if (!isEqual(value, base[key])) {
            if (isArray(value))
            result[key] = value
            else if (isObject(value) && isObject(base[key]))
            result[key] = changes(value, base[key])
            else
            result[key] = value
            if(callback && callback(base))
                result.uniqueKey = callback(base)
        }
        })
    }
    return changes(object, base)
}

export const billPeriodOpts = [
    { value: 'MONTH', label: '月度' },
    { value: 'QUARTER', label: '季度' },
    { value: 'HALF_YEAR', label: '半年' },
]

export const contractTaskBillPeriodOpts = [
    { value: 1, label: '天' },
    { value: 2, label: '周' },
    { value: 3, label: '月' },
    { value: 4, label: '季' },
    { value: 5, label: '半年' },
    { value: 6, label: '年' },
]

// type: day, hour, minute, second
export function getDuration(time, type, ms = 1) { 
    if(type === 'day') {
        return Math.floor(time / ms / 60 / 60 / 24)
    }
    if(type === 'hour') {
        let day = Math.floor(time / ms / 60 / 60 / 24)
        return Math.floor(time / ms / 60 / 60 - 24 * day)
    }
    if(type === 'minute') {
        let day = Math.floor(time / ms / 60 / 60 / 24)
        let hour = Math.floor(time / ms / 60 / 60 - 24 * day)
        return Math.floor(time / ms / 60 - 24 * 60 * day - 60 * hour)
    }
    if(type === 'second') {
        let day = Math.floor(time / ms / 60 / 60 / 24)
        let hour = Math.floor(time / ms / 60 / 60 - 24 * day)
        let minute = Math.floor(time / ms / 60 - 24 * 60 * day - 60 * hour)
        return time / ms - 24 * 60 * 60 * day - 60 * 60 * hour - 60 * minute
    }
}

export function getSeconds(time, type, ms = 1) {
    if(type === 'day') {
        return time * 24 * 60 * 60 * ms
    }
}
